import { Link } from "react-router-dom";
import "./index.css";
import useAppData from "../../hooks/useAppData";

export default function HeroBanner() {
		const {settings} = useAppData();
	return (
		<div  className="d-flex herodiv heroImg">
			<video width="100%" height="auto"  
				autoPlay
				muted
				loop
				playsInline
			>
				<source src="/assets/videos/dubai.mp4" type="video/mp4" />
				Your browser does not support the video tag.
			</video>

			<div className="container d-flex">
				{/* <img className=' w-100 h-100' src={dubaiImage} alt="dubai" /> */}
				<div className="hero-left-content">
					{/* left content */}
					<h3 className="hero-heading text-uppercase Ethnocentric">
						Delivering speed with <span>accuracy</span>
					</h3>
					<p className="heading-paragraph">
						Seamless cargo solution designed for speed, safety and global reach.
						your delivery, our priority across borders, across industries
					</p>
					<Link className="hero-button " to={`/services`}>
						Explore Our Services
					</Link>
				</div>

				<div className="hero-Right-content">
					{/* right content */}
					<div className="social-media-div">
						<div className="social-media-link">
							<a href={settings?.instagram || "https://instagram.com"}>
								<i className="bi bi-instagram"></i>
							</a>
							<a href={settings?.facebook || "https://facebook.com"}>
								<i className="bi bi-facebook"></i>
							</a>
							<a href={settings?.linkedin || "https://linkedin.com"}>
								<i className="bi bi-linkedin"></i>
							</a>
							<a href={settings?.phone_number ? `tel:${settings.phone_number}` : "tel:#"}>
								<i className="bi bi-telephone-fill"></i>
							</a>
							<a href={settings?.email ? `mailto:${settings.email}` : "mailto:#"}>
								<i className="bi bi-envelope"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
